import * as React from 'react';

import { isNativePlatform, isNativePlatformAndroid, isNativePlatformIOS } from 'components/helper/Platform';

export type NativeMobileDevicePropsType = {
	renderNative?: () => any;
	renderIOS?: () => any;
	renderAndroid?: () => any;
	renderElse?: () => any;
};

const NativeMobileDevice = ({ renderNative, renderIOS, renderAndroid, renderElse }: NativeMobileDevicePropsType) => {
	return (
		<React.Fragment>
			{isNativePlatform() && renderNative && renderNative()}
			{isNativePlatformIOS() && renderIOS && renderIOS()}
			{isNativePlatformAndroid() && renderAndroid && renderAndroid()}
			{!isNativePlatform() && renderElse && renderElse()}
		</React.Fragment>
	);
};

export default NativeMobileDevice;
